import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { SharedUiLibraryModule } from '@cudirect/shared-ui-library';
import { LenderConfiguration, LenderContact } from '@shared/model/lender-config.model';
import { LenderService } from '@shared/service/lender/lender.service';
import { NgxMaskPipe } from 'ngx-mask';

@Component({
  selector: 'dx-content-messaging-info',
  standalone: true,
  imports: [CommonModule, SharedUiLibraryModule, NgxMaskPipe],
  templateUrl: './content-messaging-info.component.html',
  styleUrl: './content-messaging-info.component.scss'
})
export class ContentMessagingInfoComponent implements OnInit, OnChanges {
  private readonly lenderService = inject(LenderService);
  public lenderData: LenderConfiguration;
  public phoneBlockHasData = false;
  public emailBlockHasData = false;
  public addressBlockHasData = false;

  @Input()
  public showPhone: boolean;
  @Input()
  public showAddress: boolean;
  @Input()
  public showEmail: boolean;
  @Input()
  public phoneLabel?: string;
  @Input()
  public emailLabel?: string;
  @Input()
  public addressLabel?: string;

  public ngOnInit(): void {
    if (this.lenderService.lenderDataInfo) {
      this.lenderData = this.lenderService.lenderDataInfo;
      this.addressBlockHasData =
        this.showAddress &&
        (this.isValueExists(this.lenderData.address1) ||
          this.isValueExists(this.lenderData.address2) ||
          this.isValueExists(this.lenderData.city) ||
          this.isValueExists(this.lenderData.state) ||
          this.isValueExists(this.lenderData.zipCode));
      this.emailBlockHasData = this.showEmail && this.isContactExists(this.contactInfoByType(this.lenderData.contacts, 'email'));
      this.phoneBlockHasData =
        this.showPhone &&
        (this.isValueExists(this.lenderData.hoursOfOperation) ||
          this.isValueExists(this.lenderData.daysOfOperation) ||
          this.isContactExists(this.contactInfoByType(this.lenderData.contacts, 'phone')));
    }
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (!this.lenderData) {
      return; // we can't update contact blocks without lender data
    }
    if (changes.showAddress) {
      this.addressBlockHasData =
        this.showAddress &&
        (this.isValueExists(this.lenderData.address1) ||
          this.isValueExists(this.lenderData.address2) ||
          this.isValueExists(this.lenderData.city) ||
          this.isValueExists(this.lenderData.state) ||
          this.isValueExists(this.lenderData.zipCode));
    }
    if (changes.showEmail) {
      this.emailBlockHasData = this.showEmail && this.isContactExists(this.contactInfoByType(this.lenderData.contacts, 'email'));
    }
    if (changes.showPhone) {
      this.phoneBlockHasData =
        this.showPhone &&
        (this.isValueExists(this.lenderData.hoursOfOperation) ||
          this.isValueExists(this.lenderData.daysOfOperation) ||
          this.isContactExists(this.contactInfoByType(this.lenderData.contacts, 'phone')));
    }
  }

  public contactInfoByType(contacts: LenderContact[], contactType: string): LenderContact[] {
    const filteredContacts = contacts?.filter((contact) => contact?.type?.toLowerCase() === contactType && contact.value);
    return filteredContacts;
  }

  public isValueExists(value: string): boolean {
    return value ? true : false;
  }

  public isContactExists(arrayValue: LenderContact[]): boolean {
    return arrayValue && arrayValue.length > 0 ? true : false;
  }
}
